import { TableAdministradora } from "./Components/table/TableAdministradora";

export const PageComissoesAdministradora = () => {
  return <TableAdministradora />;
};
